import { CheckCircle, Eye, Trash2, Loader, AlertTriangle } from "lucide-react";
import { Button, Badge, OverlayTrigger, Tooltip } from "react-bootstrap";
const getResourceStatus = (resource) => {
  // ❗ Not an AI resource at all
  if (!resource.gcs) {
    return { state: "none" };
  }

  const gcsStatus = resource.gcs.status;

  if (gcsStatus === "processing") {
    return { state: "processing", label: "File processing in progress" };
  }

  if (gcsStatus === "failed") {
    return { state: "failed", label: "File processing failed" };
  }

  if (gcsStatus === "success") {
    return { state: "ready" };
  }

  return { state: "none" };
};

export default function ImageCard({
  image,
  isSelected,
  onSelect,
  onView,
  onDelete,
  hasView = true,
  hasDelete = true,
}) {
  const imageStatus = getResourceStatus(image);
  const isSelectable = !image.gcs || imageStatus.state === "ready";

  return (
    <div
      onClick={isSelectable ? onSelect : undefined}
      className={`group relative rounded-lg overflow-hidden transition-all duration-300
    ${isSelectable ? "cursor-pointer" : "cursor-not-allowed opacity-60"}
    ${
      isSelected
        ? "ring-2 ring-blue-500 shadow-xl"
        : isSelectable
          ? "shadow-md hover:shadow-lg hover:scale-105"
          : "shadow-sm"
    }
  `}
    >
      <div className="preview relative w-full aspect-square overflow-hidden ">
        <img
          src={image.signedUrl || image.url || "/placeholder.svg"}
          alt={image.name}
          className={`w-full h-full object-cover transition-transform duration-300
    ${isSelectable ? "group-hover:scale-110" : ""}
  `}
        />

        <div
          className={`overlay absolute inset-0 transition-colors duration-300
    ${isSelectable ? "bg-black/0 group-hover:bg-black/20" : "bg-black/10"}
  `}
        />
      </div>

      {isSelected && (
        <div className="selected-badge absolute top-2 right-2 rounded-full p-1 shadow-lg">
          <CheckCircle size={24} />
        </div>
      )}

      {["processing", "failed"].includes(imageStatus.state) && (
        <OverlayTrigger
          placement="left"
          overlay={<Tooltip>{imageStatus.label}</Tooltip>}
        >
          <div className="absolute top-2 right-2 z-10">
            {imageStatus.state === "processing" && (
              <div className="bg-blue-500 text-white rounded-full p-2 shadow-md">
                <Loader size={16} className="animate-spin" />
              </div>
            )}
            {imageStatus.state === "failed" && (
              <div className="bg-red-500 text-white rounded-full p-2 shadow-md">
                <AlertTriangle size={16} />
              </div>
            )}
          </div>
        </OverlayTrigger>
      )}

      <div className="pt-4 pb-4 px-[1rem]">
        <div className="flex items-start justify-between gap-2">
          <div className="min-w-0">
            <h3 className="font-semibold text-sm truncate">{image.name}</h3>
            <p className="text-xs capitalize text-slate-500">{image.type}</p>
          </div>

          <div
            className="flex gap-2 shrink-0"
            onClick={(e) => e.stopPropagation()}
          >
            {hasView && (
              <Button
                variant="outline-primary"
                size="sm"
                onClick={() => onView(image)}
                className="p-1 flex items-center justify-center"
              >
                <Eye size={16} />
              </Button>
            )}
            {hasDelete && (
              <Button
                variant="outline-danger"
                size="sm"
                onClick={() => onDelete(image)}
                className="p-1 flex items-center justify-center"
              >
                <Trash2 size={16} />
              </Button>
            )}
          </div>
        </div>
      </div>
    </div>
  );
}
